// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { nextSunday as fn } from "../nextSunday.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const nextSundayWithOptions = convertToFP(fn, 2);

// Fallback for modularized imports:
export default nextSundayWithOptions;
